import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { useModals } from 'contexts/modals';
import React from 'react';

interface TrialModalProps {
  id: string;
  title: string;
  content: string;
  acceptText?: string;
  cancelText?: string;
  show?: boolean;
  onClose?: (accepted: boolean) => void;
}

export default function TrialModal ({
  id,
  title,
  content,
  acceptText,
  cancelText,
  onClose,
}: TrialModalProps) {
  const isOpen = useModals().isModalOpen[id];

  const handleClose = (accepted: boolean) => {
    onClose?.(accepted);
  };

  return (
    <Dialog open={!!isOpen} onOpenChange={(open) => !open && handleClose(false)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{content}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={() => handleClose(false)}>
            {cancelText || 'Cancel'}
          </Button>
          <Button
            onClick={() => handleClose(true)}
          >
            {acceptText || 'Accept'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
